import React from "react";
import { Route } from "lucide-react";
import TraceMap from "./TraceMap";
import TraceTimeline from "./TraceTimeline";

export function TraceSummary({ events }) {
  const countries = new Set(events.map((e) => e.country).filter(Boolean));
  return (
    <div className="flex flex-wrap gap-8 mb-6" data-testid="trace-summary">
      <div>
        <p className="font-display text-3xl" style={{ color: "var(--vault-gold)" }} data-testid="trace-scan-count">{events.length}</p>
        <p className="overline text-[var(--vault-text-muted)]">Scans</p>
      </div>
      <div>
        <p className="font-display text-3xl" style={{ color: "var(--vault-gold)" }} data-testid="trace-country-count">{countries.size}</p>
        <p className="overline text-[var(--vault-text-muted)]">Countries</p>
      </div>
    </div>
  );
}

export default function Traceability({ events }) {
  return (
    <section
      className="rounded-2xl p-6 sm:p-10 mb-10 fade-up delay-2"
      style={{ background: "var(--vault-surface)", border: "1px solid var(--vault-border)" }}
      data-testid="bottle-traceability"
    >
      <div className="flex items-center gap-3 mb-2">
        <Route className="w-4 h-4" style={{ color: "var(--vault-gold)" }} />
        <p className="overline text-[var(--vault-text-muted)]">Traceability</p>
      </div>
      <h2 className="font-display text-2xl sm:text-3xl mb-2">The journey of this bottle</h2>
      <p className="text-sm text-[var(--vault-text-muted)] mb-8 max-w-xl">
        Every NFC scan is recorded with its date, time and approximate city.
      </p>
      {events.length === 0 ? (
        <p className="text-sm text-[var(--vault-text-faint)] py-6" data-testid="trace-empty">
          No scans recorded yet.
        </p>
      ) : (
        <>
          <TraceSummary events={events} />
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-3 h-72 sm:h-96 rounded-xl overflow-hidden border" style={{ borderColor: "var(--vault-border)" }}>
              <TraceMap events={events} />
            </div>
            <div className="lg:col-span-2 max-h-96 overflow-auto pr-1">
              <TraceTimeline events={events} />
            </div>
          </div>
        </>
      )}
    </section>
  );
}
